import { Grid, Typography, makeStyles, } from '@material-ui/core';
import React, { useContext } from 'react';
import StoryContext from '../../contexts/StoryContext';
import MessageBox from '../MessageBox';
import SubquestionBox from '../SubquestionBox';

function Q1Conclusion() {
  const {
    lightColor, darkColor,
  } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    }
  }))();

  return (
    <SubquestionBox color={lightColor}>
      <Grid
        spacing={2}
        container
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12}>
          <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
            What does the data say?
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Grid item xs={10} sm={6}>
              <MessageBox>
                <Typography variant="h5" gutterBottom>Are children at risk of lead exposure?</Typography>
                <Typography variant="body1">
                  Many children are at risk of lead exposure in child care, particularly children of color and children from families with low incomes. While child care providers may not be able to control the pollution coming from nearby industrial sites, they can take some simple steps to begin protecting the children in their care by:
                </Typography>
                <ul>
                  <li><Typography variant="body1">Making sure your facility is free of chipping, cracking or peeling paint;</Typography></li>
                  <li><Typography variant="body1">Covering any bare soil with mulch or ground cover;</Typography></li>
                  <li><Typography variant="body1">Installing tap water filters that are certified to remove lead; and</Typography></li>
                  <li><Typography variant="body1">Requesting proof of regular blood lead level tests for children’s medical record files.</Typography></li>
                </ul>

                <Typography variant="body1">
                  For more practical steps to prevent lead exposure in child care, take a look at the link provided below for Additional Resources.
                </Typography>
              </MessageBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </SubquestionBox>
  );
}

export default Q1Conclusion;
